import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from '../../hx/useTranslation';
import '../../../styles/main.css';
import CxCombo from '../../cx/CxCombo';
import CxDate from '../../cx/CxDate';
import CxChooser from '../../cx/CxChooser';
import CxButton from '../../cx/CxButton';
import CxToolbar from '../../cx/CxToolbar';
import CxSnackbar from '../../cx/CxSnackbar';
import CxSearcher from '../../cx/CxSearcher';
import CxStatic from '../../cx/CxStatic';
import CxDlgAlert from '../../cx/CxDlgAlert';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxRegion from '../../fx/FxRegion';
//import * as FxDat from '../../fx/FxDat';
import { useSessionStorage } from '../../hx/useSessionStorage';
import { StoreLongTask, clearStore, StoreMassBilling } from "../../gx/GxStore";
import { useNav } from '../../hx/useNav';


const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'flex-start',
    gap: 'var(--ibs_container_gap)',
    margin: 'var(--ibs_container_margin)',
  },
  button_frame: {
    margin: '20px 0 0 0',
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'flex-start',
    gap: '12px',
    width: '100%',
  },
}));

const MxMassBillingOption = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navTo }] = useNav();
  const classes = useStyles(props);

  const rf_warning = React.useRef(null);
  const rf_mode = React.useRef(null);
  const rf_date = React.useRef(null);
  const rf_txTypeSeries = React.useRef(null);
  const rf_txReceiptCorrected = React.useRef(null);

  const hasColumnSeries = () => { return Boolean(localStorage.getItem('MxSlsDocList.addcol_txTypeSeries') === '1') };
  
  const r_dlg_alert = React.useRef(null);

  const r_snack_error = React.useRef(null);
  
  const [showDate, setShowDate] = React.useState(false);
  const [disableIssuing88, setDisableIssuing88] = React.useState(false);
  const [disableIssuing81, setDisableIssuing81] = React.useState(false);
  
  const [storeLongTask, setStoreLongTask] = useSessionStorage('StoreLongTask', StoreLongTask);

  // eslint-disable-next-line
  const [storeMassBilling, setStoreMassBilling] = useSessionStorage('StoreMassBilling', StoreMassBilling);

  React.useEffect(() => {
    clearStore('StoreLongTask', storeLongTask);
    formLoad();
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    if (storeMassBilling.arListedId.split('|').length-1===0) {
      setDisableIssuing88(true);
      setDisableIssuing81(true);
    }
    // eslint-disable-next-line
  }, [storeMassBilling.arListedId.split('|').length-1]);

  const formLoad = async () => {
  }

  const onSelectionMode = async (val) => {
    try {
      if (val.split('|')[0] === '0') {
        setShowDate(false);
        //rf_date.current.clear();
      } else {
        Promise.all([setShowDate(true)]).then((result) => {
          rf_date.current.setFocus();
        });
      }

    } catch (error) {
      FxLog.errorx("MxMassBillingOption.onSelectionMode", error);
    }
  }

  const issueInvoices = (op) => {
    try {
      if (rf_mode.current.getKey() === '1' && rf_date.current.isEmpty()) {
        r_snack_error.current.setVal(trans('field.required') + ': ' + trans('field.date'));
        r_snack_error.current.setOpen(true);
        return;
      }
      if (rf_txTypeSeries.current.getIsRequired() && rf_txTypeSeries.current.isEmpty()) {
        r_snack_error.current.setVal(trans('field.required') + ': ' + trans('field.series'));
        r_snack_error.current.setOpen(true);
        return;
      }

      Promise.all([FxRegion.verifactuPrecheck(storeMassBilling.arListedId.split('|').length-1)]).then((result) => {
        if (result[0]) {
          if (result[0] === 'rv_no_certificate_branch') r_dlg_alert.current.setValAndOpen('La sucursal no tiene certificado asignado', 'Ver: Configuración> Opciones> Certificados> Sucursal', 'var(--ibs_color_red)');
          if (result[0] === 'rv_nif_not_censused') r_dlg_alert.current.setValAndOpen('NIF de sucursal no censado en la AEAT', 'Ver: Configuración> Sucursales> Sucursal> Nif', 'var(--ibs_color_red)');
          if (result[0] === 'rv_receipt_limit_exceeded') r_dlg_alert.current.setValAndOpen('La cantidad de facturas a emitir excede el límite', 'El plan contratado permite hasta 500 facturas/mes', 'var(--ibs_color_red)');
          if (result[0] === 'OK') {
            let inReceiptOri = '';
            if (rf_txReceiptCorrected.current) {
              inReceiptOri = rf_txReceiptCorrected.current.getKey();
            }
      
            storeLongTask._url = 'mass_billing/issue';
            storeLongTask._canCancel = true;
            storeLongTask._record = { 
              txTaskName: "mass_billing", 
              op: op, 
              inReceiptOri: inReceiptOri,
              dtReceipt: (rf_date.current ? rf_date.current.getVal() : ''),
              itSeries: rf_txTypeSeries.current.getKey(),
              arListedId: storeMassBilling.arListedId,
            };
            Promise.all([setStoreLongTask(storeLongTask)]).then((result) => {
              navTo('mass-billing-option-tsk');
            });
          }
        }
      });

    } catch (error) {
      FxLog.errorx("MxMassBillingOption.issueInvoices", error);
    }
  }

  return (
    <div>
      <CxToolbar moduleName={`${trans('field.mass_billing')}: ${trans('field.options')}`} />

      <div className={classes.container}>
        
        {FxRegion.isSpain() && <CxStatic xref={rf_warning} label={'Seleccione serie específica para facturas rectificativas'} border='none' fontcolor='var(--ibs_color_red)' fontsize='16px' visible='false' />}

        <CxCombo xref={rf_mode}
          label={`${trans('field.mode')}`}
          list={[
            { id: '0', type: trans('field.use_x_date', 'field.invoice') },
            { id: '1', type: trans('field.use_x_date', 'field.selected_0') },
          ]}
          clearDisabled
          autoSelectFirst
          onSelection={onSelectionMode}
          required
        />

        {showDate && <CxDate xref={rf_date} label={trans('field.date')} required />}

        <CxChooser xref={rf_txTypeSeries} label={trans('field.series')}
          table="t_series"
          col_id="itSeries"
          col_tx="txTypeSeries"
          extra_filter_1={"boActive='1'"}
        />

        {storeMassBilling.inClient && 
        <CxSearcher xref={rf_txReceiptCorrected}
          label={trans('field.corrected_receipt')}
          url={`sls/doclist/r`} 
          col_id="inReceipt" 
          col_tx="txReceipt"
          filter={`n_receipt.inClient='${storeMassBilling.inClient}' and exists (select inReceiptOri from n_receipt r where r.inReceiptOri=n_receipt.inReceipt and nuTotalFinal<0)`}
          tooltip={`${trans('field.doc')} / ${trans('field.date')} / ${trans('field.client')}`}
          onClear={() => {
            setDisableIssuing88(false); 
            if (FxRegion.isSpain()) {
              rf_warning.current.setVisible(false);
              rf_txTypeSeries.current.setIsRequired(false);
            }
          }}
          onSelection={() => {
            setDisableIssuing88(true); 
            if (FxRegion.isSpain()) {
              rf_warning.current.setVisible(true);
              rf_txTypeSeries.current.setIsRequired(true);
            }
          }}
          columns={[
            { id: "0", Header: "ID", accessor: "inReceipt", show: false },
            { id: "1", Header: trans('field.series'), accessor: row => rf_txReceiptCorrected.current.getTable().highlightText(row["txTypeSeries"]), width: '14%', show: hasColumnSeries() },
            { id: "2", Header: trans('field.doc'), accessor: row => rf_txReceiptCorrected.current.getTable().highlightText(row["txReceipt"]), width: '18%' },
            { id: "3", Header: trans('field.date'), accessor: row => rf_txReceiptCorrected.current.getTable().highlightDate(row["dtReceipt"]), width: '18%' },
            { id: "4", Header: trans('field.client'), accessor: row => rf_txReceiptCorrected.current.getTable().highlightText(row["txClient"]), width: '50%' },
          ]}
          bottomLegend={`${trans('msg.void_receipts')}`}
        />}

        <CxStatic label={`${trans('field.invoices')}: ${storeMassBilling.arListedId.split('|').length-1}`} border='none' fontcolor='var(--ibs_color_blue)' fontsize='16px' />

        <div className={classes.button_frame}>
          <CxButton label={trans('field.inv_issuing_88')} style={{ width: 'var(--ibs_control_width_lg)' }} disabled={disableIssuing88} onClick={() => issueInvoices('88')} />
          <CxButton label={trans('field.inv_issuing_81')} style={{ width: 'var(--ibs_control_width_lg)' }} disabled={disableIssuing81} onClick={() => issueInvoices('81')} />
        </div>

      </div>

      <CxDlgAlert xref={r_dlg_alert} />

      <CxSnackbar xref={r_snack_error} severity="error" />

    </div>
  );

}

export default MxMassBillingOption;
